import { render, staticRenderFns } from "./LensPlatformAuthenticator.vue?vue&type=template&id=5c62e10d"
import script from "./LensPlatformAuthenticator.vue?vue&type=script&lang=js"
export * from "./LensPlatformAuthenticator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports